// Generated by purs version 0.13.8
"use strict";
var Lunarbox_Data_Dataflow_Runtime_Class_Describable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Describable/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Runnable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Runnable/index.js");
var Lunarbox_Data_Dataflow_Runtime_Class_Typeable = require("../Lunarbox.Data.Dataflow.Runtime.Class.Typeable/index.js");
var Lunarbox_Data_Editor_FunctionData = require("../Lunarbox.Data.Editor.FunctionData/index.js");
var string = {
    name: "string",
    expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableString)(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableString))("lunarbox"),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([  ])({
        name: "String",
        description: "A string which has the same value as the input textbox"
    })
};
var number = {
    name: "number",
    expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableInt)(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableInt))(0),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([  ])({
        name: "Number",
        description: "A number which has the same value as the input box"
    })
};
var $$boolean = {
    name: "boolean",
    expression: Lunarbox_Data_Dataflow_Runtime_Class_Describable.toNativeExpression(Lunarbox_Data_Dataflow_Runtime_Class_Describable.describableA(Lunarbox_Data_Dataflow_Runtime_Class_Runnable.runnableBool)(Lunarbox_Data_Dataflow_Runtime_Class_Typeable.typeableBool))(false),
    functionData: Lunarbox_Data_Editor_FunctionData.internal([  ])({
        name: "Boolean",
        description: "A boolean which has the same value as the visual switch"
    })
};
var literalNodes = [ $$boolean, number, string ];
module.exports = {
    literalNodes: literalNodes,
    "boolean": $$boolean,
    number: number,
    string: string
};
